import React from "react"
import { graphql } from "gatsby"
import linkedin from "../img/linkedin.png"
import { DiscussionEmbed } from "disqus-react"
import Content, { HTMLContent } from "../components/Content"
import { Link } from "gatsby"
import logoImg from "../img/logo-EA.png"
import ShubhamKumarGautamImg from "../img/shubham-kumar-gautam.jpg"
import RavishRajImg from "../img/ravish-raj.jpg"
import NavtoshDasImg from "../img/navtosh-kumar.jpg"
import SuyashNamdeoImg from "../img/suyash-namdeo.jpg"
import ChiranjeevKumarImg from "../img/chiranjeev-kumar.jpg"
import PrabalDuttaImg from "../img/prabal-dutta.jpg"
import Footer from "../components/footer"
import NavigationBar from "../components/Navbar"
import NewsletterStripBlogPost from "../components/newsletterStripBlogPost"
import NewsletterStrip from "../components/newsletterStrip"
import TabsRender from "../components/Tabs"
import { Helmet } from "react-helmet"

const titletemp = "title"
const pseudoCode = `int func(int a, int b){
  int a;
  cin >> a;
  return a
}`
const cppCode = "cpp"
const pythonCode = "python"
const javaCode = "java"

export const BlogPostTemplate = ({
  date,
  posttitle,
  author,
  reviewer,
  category,
  tags,
  path,
  featuredimage,
  description,
  content,
  ast,
  contentComponent,
  identifierid,
  similarBlogs,
}) => {
  const disqusShortname = "enjoyalgorithms"
  const disqusConfig = {
    identifier: identifierid ? identifierid : null,
    title: posttitle ? posttitle : null,
  }
  const PostContent = contentComponent || Content

  var authorName = null
  var authorImg = null
  var authorLink = null
  var reviewerName = null
  var reviewerImg = null
  var reviewerLink = null

  if (String(author) === "Enjoy Algorithms") {
    authorName = "Enjoy Algorithms"
    authorImg = logoImg
    authorLink = "https://www.linkedin.com/company/enjoy-algorithms"
  }

  if (String(author) === "Shubham Gautam") {
    authorName = "Shubham Gautam"
    authorImg = ShubhamKumarGautamImg
    authorLink = "https://www.linkedin.com/in/shubhamsuper30/"
  }

  if (String(author) === "Ravish Raj") {
    authorName = "Ravish Raj"
    authorImg = RavishRajImg
    authorLink = "https://www.linkedin.com/in/ravishkumar2/"
  }

  if (String(author) === "Navtosh Kumar") {
    authorName = "Navtosh Kumar"
    authorImg = NavtoshDasImg
    authorLink = "https://www.linkedin.com/in/navtosh-kumar/"
  }

  if (String(author) === "Suyash Namdeo") {
    authorName = "Suyash Namdeo"
    authorImg = SuyashNamdeoImg
    authorLink = "https://www.linkedin.com/in/suyash-namdeo-433109151/"
  }

  if (String(author) === "Prabal Dutta") {
    authorName = "Prabal Dutta"
    authorImg = PrabalDuttaImg
    authorLink = "https://www.linkedin.com/in/prabal-bijoy-dutta-711391146"
  }

  if (String(author) === "Chiranjeev Kumar") {
    authorName = "Chiranjeev Kumar"
    authorImg = ChiranjeevKumarImg
    authorLink = "https://www.linkedin.com/in/kumarchiranjeev/"
  }

  if (String(reviewer) === "Shubham Gautam") {
    reviewerName = "Shubham Gautam"
    reviewerImg = ShubhamKumarGautamImg
    reviewerLink = "https://www.linkedin.com/in/shubhamsuper30/"
  }

  if (String(reviewer) === "Ravish Raj") {
    reviewerName = "Ravish Raj"
    reviewerImg = RavishRajImg
    reviewerLink = "https://www.linkedin.com/in/ravishkumar2/"
  }

  if (String(reviewer) === "Navtosh Kumar") {
    reviewerName = "Navtosh Kumar"
    reviewerImg = NavtoshDasImg
    reviewerLink = "https://www.linkedin.com/in/navtosh-kumar/"
  }

  if (String(reviewer) === "Suyash Namdeo") {
    reviewerName = "Suyash Namdeo"
    reviewerImg = SuyashNamdeoImg
    reviewerLink = "https://www.linkedin.com/in/suyash-namdeo-433109151/"
  }

  if (String(reviewer) === "Prabal Dutta") {
    reviewerName = "Prabal Dutta"
    reviewerImg = PrabalDuttaImg
    reviewerLink = "https://www.linkedin.com/in/prabal-bijoy-dutta-711391146"
  }

  if (String(reviewer) === "Chiranjeev Kumar") {
    reviewerName = "Chiranjeev Kumar"
    reviewerImg = ChiranjeevKumarImg
    reviewerLink = "https://www.linkedin.com/in/kumarchiranjeev/"
  }

  if (String(reviewer) === "Enjoy Algorithms") {
    reviewerName = "Enjoy Algorithms"
    reviewerImg = logoImg
    reviewerLink = "https://www.linkedin.com/company/enjoy-algorithms"
  }

  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{posttitle}</title>
        <meta name="description" content="Blog Page" />
      </Helmet>
      <NavigationBar />
      <div className="relative pt-16 pb-10 overflow-hidden bg-white lg:mx-32 xl:mx-80">
        <div className="hidden lg:block lg:absolute lg:inset-y-0 lg:h-full lg:w-full"></div>
        <div className="relative px-4 sm:px-6 lg:px-4">
          <div className="mx-auto mb-6 text-lg max-w-prose">
            <h1 className="mt-2 mb-8 text-3xl font-extrabold leading-8 tracking-tight text-center text-gray-900 md:text-4xl sm:leading-10">
              {posttitle}
            </h1>
          </div>

          {featuredimage ? (
            <figure className="mx-0 lg:mx-12">
              <img
                className="w-full rounded-lg"
                src={require("../../static/" + featuredimage)}
                alt=""
              />
            </figure>
          ) : null}
          <div className="flex flex-wrap mt-10 ml-0 md:ml-24">
            {tags &&
              tags.map((tag, index) => (
                <Link
                  key={index}
                  to={`/tags/${tag}/`}
                  className="items-center px-3 py-1 mt-2 mr-6 text-sm font-medium leading-4 text-gray-700 break-normal transition duration-150 ease-in-out bg-white border border-black rounded whitespace-nowrap lg:px-6 lg:py-2 sm:px-4 sm:py-1 lg:inline-flex hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:border-indigo-300 focus:shadow-outline-indigo active:bg-indigo-200"
                >
                  {tag}
                  {/* <span className="-mt-1">👉</span> */}
                </Link>
              ))}
          </div>

          <div
            className="mt-10 ml-0 prose select-none md:ml-24 lg:prose-lg"
            dangerouslySetInnerHTML={{ __html: content }}
          ></div>

          {/* <PostContent
            className="mt-10 ml-0 prose select-none md:ml-24 lg:prose-lg"
            content={content}
            ast={ast}
          /> */}

          <div className="grid grid-cols-1 mt-10 ml-0 md:ml-24 sm:grid-cols-2">
            {author ? (
              <a
                href={authorLink}
                className="flex-shrink-0 block group focus:outline-none"
              >
                <div className="flex items-center">
                  <div>
                    <img
                      className="inline-block w-16 h-16 rounded-full"
                      src={authorImg}
                      alt=""
                    />
                  </div>
                  <div className="ml-3">
                    <p className="text-sm font-medium leading-4 text-gray-500 transition duration-150 ease-in-out group-hover:text-gray-700 group-focus:underline">
                      Author
                    </p>
                    <p className="text-sm font-medium leading-5 text-gray-700 group-hover:text-gray-900">
                      {authorName}

                      <img
                        className="inline-block w-4 h-4 ml-2 -mt-1"
                        src={linkedin}
                      />
                    </p>
                  </div>
                </div>
              </a>
            ) : null}
            {reviewer ? (
              <a
                href={reviewerLink}
                className="flex-shrink-0 block mt-6 sm:mt-0 group focus:outline-none"
              >
                <div className="flex items-center">
                  <div>
                    <img
                      className="inline-block w-16 h-16 rounded-full"
                      src={reviewerImg}
                      alt=""
                    />
                  </div>
                  <div className="ml-3">
                    <p className="text-sm font-medium leading-4 text-gray-500 transition duration-150 ease-in-out group-hover:text-gray-700 group-focus:underline">
                      Reviewer
                    </p>
                    <p className="text-sm font-medium leading-5 text-gray-700 group-hover:text-gray-900">
                      {reviewerName}
                      <img
                        className="inline-block w-4 h-4 ml-2 -mt-1"
                        src={linkedin}
                      />
                    </p>
                  </div>
                </div>
              </a>
            ) : null}
          </div>
        </div>
      </div>

      {similarBlogs && similarBlogs.length ? (
        <div className="lg:mx-36">
          <div className="divide-y-2 divide-gray-200 lg:mx-80 divide-solid">
            <h3 className="mx-auto mb-6 text-3xl font-medium text-center prose-3xl text-extrabold">
              Similar Blogs
            </h3>
            <h3></h3>
          </div>
          <div className="relative px-4 pt-2 sm:px-6 lg:px-8">
            <div className="relative mx-auto max-w-7xl">
              <div className="grid h-full max-w-lg gap-5 mx-auto mt-12 md:grid-cols-2 xl:grid-cols-3 lg:max-w-none">
                {similarBlogs.slice(0, 3).map(({ node: post }) => (
                  <Link to={post.frontmatter.path} key={post.id}>
                    <article
                      className={`h-full ${
                        post.frontmatter.featuredpost ? "is-featured" : ""
                      }`}
                    >
                      <div className="flex flex-col h-full overflow-hidden rounded-lg shadow-lg">
                        {post.frontmatter.featuredimage ? (
                          <div className="flex-shrink-0">
                            <img
                              className="object-cover w-full h-full"
                              src={require("../../static/" +
                                post.frontmatter.featuredimage)}
                              alt=""
                            />
                          </div>
                        ) : null}
                        <div className="flex flex-col justify-between flex-1 p-6 bg-white">
                          <div className="flex-1">
                            <a href="#" className="block">
                              <Link
                                className="mt-2 text-xl font-semibold leading-7 text-gray-900"
                                to={post.frontmatter.path}
                              >
                                {" "}
                                {post.frontmatter.title}{" "}
                              </Link>

                              <p className="mt-3 text-base leading-6 text-gray-500">
                                {post.excerpt}
                              </p>
                            </a>
                          </div>
                          <div className="flex items-center mt-6">
                            <div className="flex-shrink-0">
                              <a href="#">
                                <img
                                  className="w-10 h-10 rounded-full"
                                  src={logoImg}
                                  alt=""
                                />
                              </a>
                            </div>
                            <div className="ml-3">
                              <p className="text-sm font-medium leading-5 text-gray-900">
                                <a href="#" className="hover:underline">
                                  {/* {post.frontmatter.author} */}
                                  EnjoyAlgorithms
                                </a>
                              </p>
                              <div className="flex text-sm leading-5 text-gray-500">
                                <time dateTime="2020-03-16">
                                  {post.frontmatter.date}
                                </time>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </article>
                  </Link>
                ))}
              </div>
            </div>
          </div>
        </div>
      ) : (
        ""
      )}

      {disqusConfig.identifier && disqusConfig.title ? (
        <div className="relative px-0 pt-6 mx-4 mt-2 overflow-hidden bg-white shadow-sm lg:px-6 md:mx-20 lg:mx-32 xl:mx-80">
          <DiscussionEmbed
            className="mt-10"
            shortname={disqusShortname}
            config={disqusConfig}
          />
        </div>
      ) : null}
      <div className="-mt-12 md:mx-0">
        <NewsletterStrip />
      </div>
      <Footer />
    </div>
  )
}

const BlogPost = ({ data }) => {
  const { markdownRemark, allMarkdownRemark } = data // data.markdownRemark holds your post data
  const { frontmatter, html, id, htmlAst } = markdownRemark
  const similar = allMarkdownRemark.edges
  // console.log(html)
  return (
    <BlogPostTemplate
      date={frontmatter.date}
      posttitle={frontmatter.title}
      author={frontmatter.author}
      reviewer={frontmatter.reviewer}
      category={frontmatter.category}
      tags={frontmatter.tags}
      path={frontmatter.path}
      featuredimage={frontmatter.featuredimage}
      description={frontmatter.description}
      content={html}
      ast={htmlAst}
      contentComponent={HTMLContent}
      identifierid={id}
      similarBlogs={similar}
    />
  )
}

export default BlogPost

export const pageQuery = graphql`
  query($path: String!, $id: String!, $tags: [String]) {
    markdownRemark(frontmatter: { path: { eq: $path } }) {
      html
      htmlAst
      id
      frontmatter {
        date(formatString: "MMMM DD, YYYY")
        author
        category
        description
        featuredimage
        path
        reviewer
        tags
        title
      }
    }
    allMarkdownRemark(
      filter: {
        frontmatter: { tags: { in: $tags }, visibility: { eq: true } }
        id: { ne: $id }
      }
    ) {
      edges {
        node {
          frontmatter {
            author
            date(formatString: "DD MMMM YYYY")
            description
            featuredimage
            path
            reviewer
            tags
            title
            visibility
            category
          }
          id
          excerpt(pruneLength: 150)
        }
      }
    }
  }
`
